/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */


import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { getValueList, handleTokenAuth } from '../actions/api';
import { ValueList } from '../types/valueList';

const valueListAdapter = createEntityAdapter({
  // Assume IDs are stored in a field other than `valueList.id`
  selectId: (valueList: ValueList) => valueList._id,
})

const valueListSlice = createSlice({
  name: 'valueList',
  initialState: valueListAdapter.getInitialState(),
  reducers: {
    // Can pass adapter functions directly as case reducers.  Because we're passing this
    // as a value, `createSlice` will auto-generate the `valueListAdded` action type / creator
    valueListAdded: valueListAdapter.addOne,
    valueListUpdated: valueListAdapter.upsertOne,
  }
})

export const { valueListAdded, valueListUpdated } = valueListSlice.actions

// Can create a set of memoized selectors based on the location of this entity state
export const valueListSelectors = valueListAdapter.getSelectors((state: any) => state.valueList)

export default valueListSlice.reducer

const notFoundValueList = (id: string) => ({
  _id: id,
  options: [],
  name: 'not found',
  code: 'not-found',
  loaded: true,
  loading: false,
  error: true,
});

export const loadValueListById = (id: string): any => async (dispatch: any, getState: () => any) => {

  const state = getState();
  const list = valueListSelectors.selectById(state, id);
  if (list && !list.loaded) {
    return;
  }

  dispatch(valueListAdded({ _id: id, loading: true }));
  const options = handleTokenAuth(getState);
  getValueList(id, options).then(
    (valueList) => {
      dispatch(valueListUpdated({ ...valueList, loaded: true, loading: false }))
    },
    (_err: Error) => {
      dispatch(valueListUpdated(notFoundValueList(id)));
    }
  )
}
